import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConsulenteProxyService } from 'src/app/infrastructure/porto/porto-proxy-consulente/consulente-proxy.service';
import { OptionImageProvider } from './option-image-provider';

@Injectable({
  providedIn: 'root'
})
export class UserImageProviderService implements OptionImageProvider {

  constructor(private readonly consulenteProxyService: ConsulenteProxyService) { }


  getImage(id: string): Observable<Blob> {
    return this.consulenteProxyService.getConsulenteIcon(Number(id)).pipe(
      map(response => response.body!)
    )
  }

  getPlaceHolderUrl(): string {
    return './assets/images/agent-placeholder.png'
  }
}

